import { RouterContext } from '#pplx/frontend/router/RouterContext.js';
import { useContext } from 'react';
export function createNavigationGuards() {
    const guards = new Set();
    return {
        registerNavigationGuard(guard) {
            guards.add(guard);
            return () => {
                guards.delete(guard);
            };
        },
        // Defer the complete transition through guards belonging to this router only.
        requestNavigation(proceed) {
            const pending = [...guards];
            const next = () => {
                const guard = pending.shift();
                if (!guard)
                    proceed();
                else if (guards.has(guard))
                    guard(next);
                else
                    next();
            };
            next();
        },
    };
}
const unguardedNavigation = {
    registerNavigationGuard: () => () => { },
    requestNavigation: (proceed) => proceed(),
};
export function useNavigationGuards() {
    return useContext(RouterContext).navigationGuards ?? unguardedNavigation;
}
//# sourceMappingURL=navigationGuard.js.map